import { Box, Button, CircularProgress, Paper, Stack, TextField, Typography } from '@mui/material'
import SelectorGruposBalance from 'common/components/SelectorGruposBalance'
import SelectorOrganizacionCompras from 'common/components/SelectorOrganizacionCompras'
import { selectPortal } from 'features/portal/portalSlice'
import i18n from 'lang/idiomas'
import { enqueueSnackbar } from 'notistack'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import EfacturasFilters from '../components/EfacturasFilters'
import EfacturasList from '../components/EfacturasList'
import InvoiceDropZone from '../components/InvoiceDropZone'
import { InvoiceHelper } from '../helpers/InvoiceHelper'
import useFetchEfacturas from '../hooks/useFetchEfacturas'

/**
 * @module InvoiceRegistration
 */
const InvoiceRegistration = () => {
  const [numeroRemision, setNumeroRemision] = useState('')
  const [organizacionCompras, setOrganizacionCompras] = useState('')
  const [grupoBalance, setGrupoBalance] = useState('')
  const [documentType, setDocumentType] = useState('')
  const [ficheros, setFicheros] = useState([])
  const { response: efaturaList, loading, reFetch } = useFetchEfacturas({ documentType })
  const [sendingInvoices, setSendingInvoices] = useState(false)
  const portal = useSelector(selectPortal)

  const clearAllInputHandler = () => {
    setNumeroRemision('')
    setOrganizacionCompras('')
    setFicheros([])
  }

  const submitHandler = () => {
    if (!ficheros.length) {
      enqueueSnackbar(
        i18n.t('efactura.errselar', { defaultValue: 'Se debe seleccionar un archivo' }),
        { variant: 'error' },
      )
      return
    }
    setSendingInvoices(true)
    InvoiceHelper.createInvoice({
      ficheros,
      idioma: '01',
      numero_remision: numeroRemision,
      organizacion_compras: organizacionCompras,
      grupo_balance: grupoBalance,
    })
      .then((res) => {
        enqueueSnackbar(
          i18n.t('efactura.ficsubco', { defaultValue: 'Los ficheros se han subido correctamente' }),
          {
            variant: 'success',
          },
        )
        reFetch()
        clearAllInputHandler()
      })
      .catch((err) => {
        enqueueSnackbar(err.message, { variant: 'error' })
      })
      .finally(() => {
        setSendingInvoices(false)
      })
  }

  return (
    <Box>
      <Paper sx={{ p: 4, mb: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {portal?.portal?.cfdi_pedir_remision !== 'N' && (
            <Box>
              <Typography variant="body1">
                {i18n.t('efactura.numremi', { defaultValue: 'Número remisión' })}
              </Typography>
              <TextField
                value={numeroRemision}
                onChange={(e) => setNumeroRemision(e.target.value)}
                InputLabelProps={{ shrink: true }} // This will keep the label fixed in its position
                fullWidth
                placeholder={i18n.t('efactura.numremi', { defaultValue: 'Número remisión' })}
                autoFocus={true}
              />
            </Box>
          )}
          <SelectorGruposBalance grupoBalance={grupoBalance} handleChange={setGrupoBalance} />
          <SelectorOrganizacionCompras
            organizacionCompras={organizacionCompras}
            handleChange={setOrganizacionCompras}
            grupoBalance={grupoBalance}
          />
          <Box>
            <InvoiceDropZone
              setFicheros={setFicheros}
              ficheros={ficheros}
              maxFiles={10}
              sx={{ bgcolor: '#FFF' }}
            />
          </Box>
          <Stack direction={'row'} spacing={5}>
            <Button variant="contained" onClick={submitHandler} disabled={sendingInvoices}>
              {i18n.t('efactura.envfact', { defaultValue: 'Enviar Facturas' })}{' '}
              {sendingInvoices && <CircularProgress sx={{ position: 'absolute' }} size={20} />}
            </Button>
            <Button variant="contained" onClick={clearAllInputHandler}>
              {i18n.t('general.cancelar', { defaultValue: 'Cancelar' })}
            </Button>
          </Stack>
        </Box>
      </Paper>

      <EfacturasFilters loader={loading} handleDocumentType={setDocumentType} />
      <EfacturasList efacturasList={efaturaList} loading={loading} />
    </Box>
  )
}

export default InvoiceRegistration
